export default "/images/smart_contracts_development/how_nfts_work.png";